module.exports = __webpack_public_path__ + "static/media/typewriter-md.d2373954.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/static/images/typewriter-md.jpg
// module id = 1129
// module chunks = 0